// extracted by css-extract-rspack-plugin
export default {"CommentsSideHeading":"CommentsSidePanel-module__CommentsSideHeading__ONbgN","SidePanelFooter":"CommentsSidePanel-module__SidePanelFooter__ORKvZ"};